import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { DatePickerModule } from '@progress/kendo-angular-dateinputs';
import { DialogsModule } from '@progress/kendo-angular-dialog';
import { DropDownListModule, MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { GridModule } from '@progress/kendo-angular-grid';
import { IconsModule } from '@progress/kendo-angular-icons';
import { IndicatorsModule } from '@progress/kendo-angular-indicators';
import { FormFieldModule, InputsModule, TextBoxModule } from '@progress/kendo-angular-inputs';
import { LabelModule } from '@progress/kendo-angular-label';
import { ContextMenuModule, MenuModule } from '@progress/kendo-angular-menu';
import { PopupModule } from '@progress/kendo-angular-popup';
import { SharedModule } from 'src/app/shared/shared.module';
import { NewStudentComponent } from './new-student/new-student.component';
import { StudentSearchRoutingModule } from './student-search-routing.module';
import { StudentSearchComponent } from './student-search.component';
import { ExpansionPanelModule } from '@progress/kendo-angular-layout';

@NgModule({
  declarations: [
    StudentSearchComponent,
    NewStudentComponent
  ],
  imports: [
    CommonModule,
    StudentSearchRoutingModule,
    DialogsModule,
    ButtonsModule,
    InputsModule,
    LabelModule,
    DropDownListModule,
    MultiSelectModule,
    DatePickerModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    IndicatorsModule,
    PopupModule,
    MenuModule,
    IconsModule,
    ButtonsModule,
    FormFieldModule,
    TextBoxModule,
    SharedModule,
    ContextMenuModule,
    ExpansionPanelModule
  ],
  exports: [
    StudentSearchComponent,
    NewStudentComponent
  ],
})
export class StudentSearchModule { }
